import classNames from 'classnames'
import type { ElementType } from 'react'

import { Box } from './Box'
import type { GridProps } from './types'

const defaultElement = 'div'

export const Grid = <C extends ElementType = typeof defaultElement>({
  className,
  children,
  as,
  ...props
}: GridProps<C>): JSX.Element => {
  const element: React.ElementType = as || defaultElement
  return (
    <Box as={element} className={classNames('grid', className)} {...props}>
      {children}
    </Box>
  )
}
